<template>
  <div id="defaultId1" class="mgmt_page_root">
    <div id="g10347" class="u9f344 pb20">
      <card
        id="g6b57e"
        v-show="detailOrList == 'list' && tableData.length > 0"
        class="u9oZ7K7"
        :isShowLabel="true"
        :label="$t('Management.Management')"
        color="#1290c9"
      >
        <template slot="right_view">
          <div
            id="g06099"
            class="u8cef5 mgmt_right_title"
            v-if="SearchEmailshow"
            @click="SearchEmailis()"
            href
          >
            {{ $t("Management.Searchmoreemails") }}
          </div>
          <el-input
            autocomplete="off"
            v-model="SearchEmail"
            style="width: 400px; font-size: 1.42rem"
            @change="getCompanyManagemenList()"
            v-else
            placeholder="Enter Email"
          ></el-input>
        </template>
        <div id="idc1w2l9" class="table_X uKJKcNl">
          <div class="mgmt_table_body">
            <el-table
              id="cbc0bc"
              class="mgmt_main_table mgmt_table"
              :data="tableData"
              empty-text="No data available at the moment"
            >
              <el-table-column
                id="c54c13"
                class="uMxWZAr"
                prop="name"
                :label="$t('Management.Name')"
                width="300"
                class-name="company_link_tooltip_normal"
                align="left"
                show-overflow-tooltip
              >
                <template id="idMh7kvx" slot-scope="scope">
                  <span id="idVwvGs9" v-if="scope.row.pid == '-'">
                    {{ scope.row.name }}
                  </span>
                  <span
                    v-else
                    id="idVwvGs9"
                    style="
                      color: #1290c9 !important;
                      text-decoration: underline !important;
                      cursor: pointer;
                    "
                  >
                    <el-popover
                      popper-class="table_popover Management-people"
                      placement="right"
                      trigger="click"
                      :disabled="!powerArr[1]?.hasPrivilege"
                    >
                      <div class="Management-people-box" v-loading="Loading">
                        <div class="Management-people-box-head">
                          <div class="flex_center_start_box">
                            <span class="anagement-people-box-name">{{
                              persinDetail.name
                            }}</span
                            ><span
                              class="anagement-people-box-name anagement-people-box-nametwo"
                              >{{ persinDetail.otherName }}</span
                            >
                          </div>
                          <p class="anagement-people-box-heng"></p>
                        </div>
                        <div class="margin-top20">
                          <div class="flex_center_start_box margin-bottom10 people_detail">
                            <span
                              class="Management-people-content"
                              style="width: 34%; text-align: left"
                              >{{ $t("Management.Roles") }}:</span
                            >
                            <span
                              class="Management-people-content Management-people-content-black"
                              >{{ persinDetail.roles }}</span
                            >
                          </div>
                          <div class="flex_center_start_box margin-bottom10 people_detail">
                            <span
                              class="Management-people-content"
                              style="width: 34%; text-align: left"
                              >{{ $t("Management.EducationLevel") }}:</span
                            >
                            <span
                              class="Management-people-content Management-people-content-black"
                              >{{ persinDetail.education }}</span
                            >
                          </div>
                          <div class="flex_center_start_box margin-bottom10 people_detail">
                            <span
                              class="Management-people-content"
                              style="width: 34%; text-align: left"
                              >{{ $t("Management.Phone") }}:</span
                            >
                            <span
                              class="Management-people-content Management-people-content-black"
                              >{{ persinDetail.phone }}</span
                            >
                          </div>
                          <div class="flex_center_start_box people_detail">
                            <span
                              class="Management-people-content"
                              style="width: 34%; text-align: left"
                              >{{ $t("Management.Email") }}:</span
                            >
                            <span
                              class="Management-people-content Management-people-content-black"
                              >{{ persinDetail.email }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <span
                        slot="reference"
                        @click="selectList('name', scope.row)"
                      >
                        {{ scope.row.name }}
                      </span>
                    </el-popover>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                id="c4a5d7"
                class="u5UjLPj"
                prop="position"
                :label="$t('Management.Position')"
                width="300"
                class-name="company_link_tooltip_normal"
                align="left"
                show-overflow-tooltip
              >
                <template #header>
                  <el-select
                    popper-class=" common_select common_selecttwo"
                    id="idAvxK9d"
                    v-model="PostionsvValue"
                    @visible-change="cutSelectCountryvisiblone"
                    v-show="!showSelectP"
                    class="mgmt_input"
                    placeholder="Please"
                    @change="cutSelectPositontwo(showSelectP)"
                  >
                    <el-option
                      id="idwakWWT"
                      v-for="item in tableDataPostion"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                  <span id="idv2v97T" v-show="showSelectP" class="uDWVvds">
                    <span id="idRT47of" class="ua9b69"
                      >{{ $t("Management.Position") }}
                    </span>
                    <span
                      id="idTpzzsx"
                      @click="cutSelectPositon(showSelectP)"
                      class="uwADSr7"
                    >
                      <svg
                        id="idb5xIgF"
                        v-if="tableDataPostion.length > 1"
                        class="icon select_icon"
                        t="1719195984272"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="4517"
                        width="18px"
                        height="10px"
                      >
                        <path
                          id="id69dvDu"
                          d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                          fill="#1290C9"
                          p-id="4518"
                        ></path>
                      </svg>
                    </span>
                  </span>
                </template>
              </el-table-column>
            <!-- <el-table-column id="c607a0" class="uWpGliS" prop="gender" label="Gender" align="center">
            </el-table-column> -->
            <el-table-column
              :label="$t('Management.Department')"
              prop="department"
              min-width="150"
              align="left"
              show-overflow-tooltip
              :resizable="false"
            />
            <el-table-column
              id="c8fa16"
              class="uXGOdre"
              prop="country"
              min-width="150"
              show-overflow-tooltip
              :label="$t('Management.Country')"
              align="left"
            >
              <template #header>
                <!-- 下拉框 -->
                <el-select
                  popper-class="common_select common_selecttwo"
                  id="id9USnbO"
                  v-model="value"
                  @visible-change="cutSelectCountryvisible"
                  v-if="!showSelectC"
                  class="mgmt_input"
                  placeholder="Please"
                  @change="cutSelectCountrytwo(showSelectC)"
                >
                  <el-option
                    id="idUvuZsz"
                    v-for="item in tableDataCountry"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
                <!-- 按钮 -->
                <span id="cc541e" v-show="showSelectC" class="uDWVvds">
                  <span id="c7ca11" class="uR11abT ua9b69"
                    >{{ $t("Management.Country") }}
                  </span>
                  <span id="idLtLri1" @click="cutSelectCountry(showSelectC)">
                    <svg
                      id="cce00a"
                      v-if="tableDataCountry.length > 1"
                      class="icon uQ9MD39 select_icon"
                      t="1719195984272"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4517"
                      width="18px"
                      height="10px"
                    >
                      <path
                        id="c70f64"
                        class="ubLoFDl"
                        d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#1290C9"
                        p-id="4518"
                      ></path>
                    </svg>
                  </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column
              id="idkJdZqc"
              class="u1wvOcS"
              prop="shareholder"
              width="220"
              :label="$t('Management.ShareholderNot')"
              align="left"
            >
            </el-table-column>
            <el-table-column
              prop="relations"
              :label="$t('Management.Relation')"
              width="150"
              align="right"
            >
              <template slot-scope="scope">
                <div
                  id="idPET7TN"
                  v-if="scope.row.relations == '-' || scope.row.relations == 0"
                  class=""
                  style="justify-content: flex-start"
                >
                  -
                </div>
                <div
                  id="idPET7TN"
                  v-else
                  @click="selectList('detail', scope.row)"
                  class=""
                >
                  <svg
                    id="idJqh8aW"
                    class="icon main_icon_search"
                    t="1719199588774"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4756"
                    width="28px"
                    height="28px"
                  >
                    <path
                      id="idJfvhvm"
                      d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                      fill="#1290C9"
                      p-id="4757"
                    ></path>
                  </svg>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              id="id6vwUJl"
              class="u1wvOcS"
              prop="verify"
              width="150"
              align="center"
              :label="$t('Management.Verification')"
            >
              <template slot-scope="scope">
                <div
                  id="id9Qc9tH"
                  class="udQ6VuV center_con"
                  style="line-height: 15px !important"
                >
                  <a
                    v-if="powerArr[3]?.hasPrivilege"
                    :href="
                      'mailto:service@csibizinfo.com?subject=information need to correct&body=Customer service, hello: %0D%0Aand The information about ' +
                      scope.row.name +
                      ' the manager of a certain company, is incorrect. %0D%0Aand The incorrect information is as follows (please enter the information you need to %0D%0Aand correct below)'
                    "
                  >
                    <el-popover
                      popper-class="table_popover"
                      placement="top"
                      trigger="hover"
                    >
                      <p>{{ $t("Management.UserSelfVerification") }}</p>
                      <img
                        slot="reference"
                        class="Verificati-img"
                        src="../../../../assets/images/huiduihao.png"
                        alt=""
                      />
                    </el-popover>
                  </a>
                  <svg
                    v-else
                    slot="reference"
                    @click="
                      $bus.$emit(
                        'show-permission-dialog',
                        '您没有权限访问该功能！',
                      )
                    "
                    t="1746777002400"
                    id="idJ9EFft"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6461"
                    width="28"
                    height="28"
                  >
                    <path
                      d="M939.36 218.912a32 32 0 0 1 45.856 44.672l-538.016 552a32 32 0 0 1-43.776 1.92L63.872 526.048a32 32 0 1 1 41.696-48.544l316.768 271.936L939.36 218.88z"
                      fill="#999999"
                      p-id="6462"
                    ></path>
                  </svg>
                </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div id="c9e47e" class="u74df0">
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                 <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span>  results for "{{
                  $t("Management.Management")
                }}"
              </div>
            </div>
            <!-- <div id="c5be9c" class="ufa40e show_AllHeight" @click="MoreList(true)">
              <div id="cc207e" class="u9rstct show_All">
                Show More
              </div>
            
            </div> -->
          </div>
        </div>
      </card>
      <!-- 放大镜部分 -->
      <card
        id="idkuoull"
        v-show="detailOrList == 'detail'"
        :isShowLabel="true"
        :label="detailTitle"
      >
        <template id="idAoXQTZ" slot="left_icon">
          <div
            id="idqIAmt9"
            @click="selectList('list')"
            class="uWVEVja uo4Jucf back_div"
          >
            <svg
              t="1728612191932"
              class="icon back_div_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9222"
              width="26px"
              height="24px"
            >
              <path
                d="M879.476364 470.341818H244.829091L507.112727 209.454545a41.658182 41.658182 0 0 0-58.88-58.88L114.967273 482.676364a41.890909 41.890909 0 0 0 0 58.88l333.265454 333.032727a41.658182 41.658182 0 0 0 58.88 0 41.890909 41.890909 0 0 0 0-58.88L244.829091 553.658182h634.647273a41.658182 41.658182 0 1 0 0-83.316364z"
                p-id="9223"
                fill="#1296db"
              ></path>
            </svg>
          </div>
        </template>
        <div id="cd5e02" class="table_X uKJKcNl uca6v5N">
          <div class="mgmt_table_body">
            <el-table
              id="c7d934"
              class="mgmt_table mgmt_main_table"
              empty-text="No Data"
              :data="detailData"
              align="center"
            >
            <el-table-column
              id="cd2c88"
              class="uMxWZAr uecRhHP"
              prop="companyName"
              :label="$t('MyDatabase.CompanyName')"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.id3a == '-'">
                  {{ scope.row.companyName }}
                </span>
                <span
                  class="company_link"
                  v-else
                  @click="setid(scope.row)"
                  style=""
                >
                  {{ scope.row.companyName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              id="c4b714"
              class="uWpGliS us3g9aG"
              align="center"
              prop="companyType"
              :label="$t('RelatedCompanies.Type')"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="c7a5ff"
              class="u1wvOcS uoivu5Z"
              prop="country"
              align="center"
              :label="$t('Management.Country')"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="cb76c8"
              class="u1wvOcS uAgbG4I"
              prop="relations"
              align="center"
              :label="$t('Management.Relation')"
              show-overflow-tooltip
            >
            </el-table-column>
            </el-table>
          </div>
          <div
            id="c9e47e"
            class="u74df0"
            @click="MoreList(false)"
            v-if="this.pageTwo.total > this.pageTwo.pageSize"
          >
            <div id="c5be9c" class="ufa40e show_AllHeight">
              <div id="cc207e" class="u9rstct show_All">Show More</div>
            </div>
          </div>
        </div>
      </card>
      <!-- Name 部分 -->
      <card
        id="idiuAdfT"
        v-show="detailOrList == 'name'"
        :isShowLabel="true"
        :label="detailTitle"
      >
        <template id="c90e02" class="ukP5To3" slot="left_icon">
          <div
            id="c76c21"
            @click="selectList('list')"
            class="uWVEVja udLbgWH uvCLCSZ back_div"
          >
            <svg
              t="1728612191932"
              class="icon back_div_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9222"
              width="26px"
              height="24px"
            >
              <path
                d="M879.476364 470.341818H244.829091L507.112727 209.454545a41.658182 41.658182 0 0 0-58.88-58.88L114.967273 482.676364a41.890909 41.890909 0 0 0 0 58.88l333.265454 333.032727a41.658182 41.658182 0 0 0 58.88 0 41.890909 41.890909 0 0 0 0-58.88L244.829091 553.658182h634.647273a41.658182 41.658182 0 1 0 0-83.316364z"
                p-id="9223"
                fill="#1296db"
              ></path>
            </svg>
          </div>
        </template>
        <div id="gc1980" class="pb30">
          <div id="idpvu5VL" class="uUXjuvB">
            <contentText
              id="idbn4WUA"
              class="u19uWWd"
              fontFamily="Arial Bold"
              :label="$t('Management.Name')"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="idnDVRE2" class="u8iAMza">{{ detailTitle }}</div>
            </contentText>
            <contentText
              id="idvac8WV"
              :label="$t('Management.Country')"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="idVdp4mB" class="ue7XKb9">
                {{ persinDetail?.country }}
              </div>
            </contentText>
          </div>
          <div id="cea99f" class="uUXjuvB">
            <contentText
              id="c14704"
              class="u19uWWd"
              label="Other Name"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="cfbf19" class="u8iAMza">
                {{ persinDetail?.otherName }}
              </div>
            </contentText>
            <contentText
              id="cd0a7f"
              class="u6Hi4Um"
              :label="$t('Management.Roles')"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="c96752" class="ue7XKb9">{{ persinDetail?.roles }}</div>
            </contentText>
          </div>
          <div id="c02adb" class="uUXjuvB">
            <contentText
              id="ccd42d"
              class="u19uWWd"
              label="Gender"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="c0b5f0" class="u8iAMza">{{ persinDetail?.gender }}</div>
            </contentText>
            <contentText
              id="c0c778"
              class="u6Hi4Um"
              :label="$t('Management.Relation')"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="c5fb06" class="ue7XKb9">
                {{ persinDetail?.relations }}
              </div>
            </contentText>
          </div>
          <div id="c0137f" class="uUXjuvB">
            <contentText
              id="c48339"
              class="u19uWWd"
              label="Age"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="cd23f7" class="u8iAMza">{{ persinDetail?.age }}</div>
            </contentText>
            <contentText
              id="ca6eb2"
              class="u6Hi4Um"
              :label="$t('Management.Phone')"
              fontFamily="Arial Bold"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="ceccd7" class="ue7XKb9">{{ persinDetail?.phone }}</div>
            </contentText>
          </div>
          <div id="c04af7" class="uUXjuvB">
            <contentText
              id="cc3beb"
              class="u19uWWd"
              fontFamily="Arial Bold"
              :label="$t('Management.EducationLevel')"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="c5e3b0" class="u8iAMza">
                {{ persinDetail?.education }}
              </div>
            </contentText>
            <contentText
              id="c7b846"
              class="u6Hi4Um"
              fontFamily="Arial Bold"
              :label="$t('Management.Email')"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="ccba97" class="ue7XKb9 u87e66">
                <a
                  id="cd7a3e"
                  class="u61a08 u4a559"
                  style="color: #1290c9"
                  :href="'mailto:' + persinDetail?.email"
                >
                  {{ persinDetail?.email }}
                </a>
              </div>
            </contentText>
          </div>
          <div id="c9fc4b" class="uUXjuvB u8174d">
            <contentText
              id="c5d997"
              class="u19uWWd u57b2e"
              fontFamily="Arial Bold"
              label="Experience"
              contentAlign="flex-start"
              titleWidth="160px"
              marginRight="2.14em"
            >
              <div id="c33584" class="u8iAMza">
                {{ persinDetail?.experience }}
              </div>
            </contentText>
          </div>
        </div>
      </card>
      <!-- <PermissionDialog></PermissionDialog> -->
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    <el-dialog
      :visible.sync="moreEmail"
      class="mgmt_page_root"
      :append-to-body="true"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normalmengent"
    >
      <div class="right_cont">
        <div class="title flex_center_between_box mgmt_page_root_dialog_title">
          <div class="tbl_search-Num">Found <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ pageTree.total }}&nbsp;</span> results</div>
          <div class="title_txt-right">
            <div class="tbl_search_box flex_end margin-top20">
              <div
                class="Back-blue margin-top30"
                v-if="backWeb && keyWord"
                @click="backWebFunction"
              >
                Back
              </div>

              <div
                class="tbl_search margin-top30 mgmt_input"
                v-if="otherEmairs"
              >
                <el-input
                  v-model="keyWord"
                  type="text"
                  class="mgmt_input_alert_website"
                  :placeholder="$t('Management.PleaseenterWebsite')"
                  @change="searchPersonByWord()"
                />
                <svg
                  t="1730778335416"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  @click="searchPersonByWord()"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9689"
                  width="24px"
                  height="24px"
                >
                  <path
                    d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                    fill="#1296db"
                    p-id="9690"
                  ></path>
                </svg>
              </div>
              <div
                v-else
                id="g06099"
                class="u8cef5 margin-top30 mgmt_right_title"
                @click="otherEmairs = true"
              >
                {{ $t("Management.Searchmore") }}
              </div>
            </div>
          </div>
        </div>
        <div class="right_cont_box">
          <div class="table_box p_l_n">
            <div class="tbl_search_box tbl_search2" v-show="isNameSearch">
              <div class="tbl_search mgmt_input">
                <el-input
                  v-model="searchTblName"
                  class="mgmt_input_alert_name"
                  type="text"
                  :placeholder="$t('Management.Pleaseentername')"
                  @change="searchPersonByName()"
                  @blur="seach"
                />
                <svg
                  t="1730778335416"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9689"
                  width="24px"
                  height="24px"
                >
                  <path
                    d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                    fill="#1296db"
                    p-id="9690"
                  ></path>
                </svg>
                <!-- <img src="../../assets/img/detail/search_ic1.png" @click="searchPersonByName" /> -->
              </div>
            </div>
            <el-table
              ref="treeTable"
              style="width: 100%"
              class="mgmt_alert_table mgmt_table"
              :data="managementTable1"
              border
            >
              <!-- 空数据状态的插槽 -->
              <template slot="empty"> No Data </template>
              <el-table-column
                :label="$t('Management.Name')"
                prop="name"
                align="left"
                width="310"
                show-overflow-tooltip
                :resizable="false"
                class-name="company_link"
              >
                <template slot="header">
                  <span class="table_add" @click="showSearchPerson()">
                    {{ $t("Management.Name") }}
                    <svg
                      t="1730778335416"
                      class="icon mgmt_alert_context_icon_search"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9689"
                      width="24px"
                      height="24px"
                    >
                      <path
                        d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                        fill="#1296db"
                        p-id="9690"
                      ></path>
                    </svg>
                  </span>
                </template>
                <template slot-scope="scope">
                  <span class="">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('Management.Position')"
                prop="position"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />

              <el-table-column
                :label="$t('Management.Email')"
                prop="email"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
                <template #header>
                  <span class="table_add" v-if="!isNameSearchTwo">
                    {{ $t("Management.Email") }}
                  </span>
                  <el-input
                    v-if="isNameSearchTwo"
                    v-model="searchTblName"
                    type="text"
                    :placeholder="$t('Management.Pleaseentername')"
                    @change="searchPersonByName()"
                    @blur="seach"
                  />
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('Management.Phone')"
                prop="phone"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('Management.Verified')"
                width="110"
                prop="verified"
                align="center"
                show-overflow-tooltip
                :resizable="false"
                class-name="company_link"
              >
                <template slot-scope="scope">
                  <button style="background-color: transparent">
                    <el-popover
                      popper-class="table_popover table_popovertwo"
                      placement="top"
                      trigger="click"
                    >
                      {{ $t("Management.Userverified") }}
                      <img
                        slot="reference"
                        v-if="scope.row.verified == '1'"
                        style="height: 2.14285714rem"
                        src="../../../../assets/images/managent-renzheng.png"
                        alt=""
                      />
                    </el-popover>
                    <!-- <svg v-if="scope.row.verified == '1'" t="1730796998351" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18647" width="40" height="40"><path d="M766 272H258c-22.1 0-40 17.9-40 40v400c0 22.1 17.9 40 40 40h508c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40z m-98 30v100.3c0 2.4-2.7 3.9-4.7 2.5l-23-17.3-11.5-8.1c-3.5-2.4-8.1-2.4-11.5 0l-11.5 8.1-23 17.3c-2 1.4-4.7 0-4.7-2.5V302H668z m108 400c0 11-9 20-20 20H268c-11 0-20-9-20-20V322c0-11 9-20 20-20h280v150.7c0 8.1 9.1 12.8 15.8 8.2l53.5-44.8c3.5-2.4 8.1-2.4 11.5 0l53.5 44.8c6.6 4.7 15.8-0.1 15.8-8.2V302H756c11 0 20 9 20 20v380z" fill="#1296db" p-id="18648"></path><path d="M458.1 399h-150c-8.3 0-15 6.7-15 15s6.7 15 15 15h150c8.3 0 15-6.7 15-15s-6.7-15-15-15zM458.1 497h-150c-8.3 0-15 6.7-15 15s6.7 15 15 15h150c8.3 0 15-6.7 15-15s-6.7-15-15-15zM458 595H308.6c-8.3 0-15 6.7-15 15s6.7 15 15 15H458c8.3 0 15-6.7 15-15s-6.7-15-15-15zM693.7 520.4l-88.4 88.4-53-53c-5.9-5.9-15.4-5.9-21.2 0-5.9 5.8-5.9 15.3 0 21.2l63.6 63.6c2.9 3 6.7 4.4 10.6 4.4 3.8 0 7.7-1.5 10.6-4.4l99-99c5.9-5.8 5.9-15.3 0-21.2-5.8-5.9-15.3-5.9-21.2 0z" fill="#1296db" p-id="18649"></path></svg> -->
                  </button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="pageTree.total"
                :pageSize.sync="pageTree.pageSize"
                :currentPage="pageTree.pageNo"
                :isDialog="true"
                @onPageChange="onPageChangeListTree"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ pageTree.pageNo }}-{{ pageTree.pageSize }} of over
                 <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ pageTree.total | FilterNum }}&nbsp;</span>  results for "{{ websitePage }}"
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  <!--srcviewscompanydetailsBackgroundManagementvuehtmlEnd-->
</template>

<script>
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import {
  getCompanyManagement,
  searchMoreEmail,
  getManagementFilter,
  getManagementSummary,
  getPersonProfile,
  getPersonRelateCompany,
  getPartPrivilege,
} from "@/api/companyApi";
// interfaceCode
//importStart

import contentText from "../../../../components/text_content/index.vue";
import card from "../../../../components/gui_card/gui_card.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import Page from "../../../../components/page/index.vue";

//importEnd

export default {
  name: "performance",
  props: {},
  mounted() {
    this.getPartPrivilege();
    this.getCompanyManagemenList();
    this.getRelatedSummaryList();
    this.getManagementFilter();
  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getRelatedSummaryList();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  components: {
    card,
    contentText,
    PermissionDialog,
    ReLogin,
    Page,
  },

  data() {
    return {
      managementTable1: [],
      reLoginVis: false,
      isNameSearch: false,
      isNameSearchTwo: false,
      otherEmairs: false,
      Loading: false,
      keyWord: "",
      isShow: {
        show: true,
      },
      searchTblName: "",
      moreEmail: false,
      backWeb: false,
      SearchEmail: "",
      // detailsORcategory
      detailsORcategory: "list",
      // showDetails
      showDetails: true,
      // detailOrList
      detailOrList: "list",
      // tableData
      tableData: [],
      tableDataCountry: [],
      tableDataPostion: [],
      // value
      value: "",
      PostionsvValue: "",
      // showSelectP
      showSelectP: true,
      // options
      options: [
        {
          value: "选项1",
          label: "CEO",
        },
        {
          value: "选项2",
          label: "CFO",
        },
        {
          value: "选项3",
          label: "OFO",
        },
      ],
      optionsCountry: [
        {
          value: "US",
          label: "US",
        },
        {
          value: "CN",
          label: "CN",
        },
      ],
      title: {},
      // showSelectC
      showSelectC: true,
      SearchEmailshow: true,
      // detailTitle
      detailTitle: "Julian Chen",
      // detailData
      detailData: [],
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      pageTwo: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      pageTree: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      persinDetail: {},
      powerArr: [],
      websitePage: "",
      // srcviewscompanydetailsBackgroundManagementvueDataEnd
    };
  },
  methods: {
    closeDialog() {
      this.moreEmail = false;
      this.backWeb = false;
    },

    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getCompanyManagemenList();
    },

    onPageChangeListTree({ page, size }) {
      this.pageTree.pageNo = page;
      this.pageTree.size = size;
      this.searhinfo();
    },

    MoreListtree() {
      if (this.pageTree.total > this.pageTree.pageSize) {
        this.pageTree.pageSize = this.pageTree.pageSize + 5;

        this.searhinfo();
      }
    },
    backWebFunction() {
      this.pageTree.pageNo = 1;
      this.keyWord = "";
      (this.backWeb = false), this.searhinfo();
    },
    searchPersonByWord() {
      this.pageTree.pageNo = 1;
      (this.backWeb = true), this.searhinfo();
    },
    // 获取 input 搜索信息
    searhinfo() {
      const base = JSON.parse(localStorage.getItem("CompanyBase"));
      const website = this.keyWord == "" ? base.base.website : this.keyWord;
      this.websitePage = this.keyWord == "" ? base.base.website : this.keyWord;
      let params = {};
      // if(this.keyWord){
      //   params= {
      //   page: this.pageTree.pageNo,
      //   pageSize: this.pageTree.pageSize,
      //   id3a: this.$route.query.id3a,
      //   keyWord: this.keyWord,
      //   website: website,
      //   countryCode: base.base.countryFlag,
      // }

      // }else{
      params = {
        page: this.pageTree.pageNo,
        pageSize: this.pageTree.pageSize,
        id3a: this.$route.query.id3a,
        keyWord: this.searchTblName,
        website: website,
        countryCode: base.base.countryFlag,
      };
      // }

      searchMoreEmail(params).then((result) => {
        if (result.code == 200) {
          this.managementTable1 =
            result.data?.contacts == undefined ? [] : result.data?.contacts;
          this.pageTree.total =
            result.data?.total == undefined ? "" : result.data?.total;
        } else {
          this.managementTable1 = [];
          this.pageTree.total = 0;
        }
      });
    },
    sortName(a, b) {
      return a.name.localeCompare(b.name);
    },
    seach() {
      if (this.searchTblName == "") {
        this.isNameSearch = false;
      }
    },
    //table 搜索
    showSearchPerson() {
      this.isNameSearch = !this.isNameSearch;
    },
    // search more eamil
    SearchEmailis() {
      if (this.powerArr[0]?.hasPrivilege) {
        this.searchTblName = "";
        this.keyWord = "";
        this.moreEmail = true;
        this.otherEmairs = false;
        this.pageTree.pageNo = 1;
        this.searhinfo();
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "413")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "414")[0];
        this.powerArr[2] = res.data.filter((item) => item.id == "415")[0];
        this.powerArr[3] = res.data.filter((item) => item.id == "416")[0];
        this.powerArr[4] = res.data.filter((item) => item.id == "417")[0];
      });
    },
    // 跳转
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.id3a +
          "/background/snapshot?id3a=" +
          row.id3a +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    searchPersonByName() {
      if (this.searchTblName == "") {
        this.isNameSearch = false;
      }
      this.searhinfo();
    },
    getRelatedSummaryList() {
      const id3a = this.$route.query.id3a;
      getManagementSummary({ id3a: id3a }).then((res) => {
        if (res.code == 200) {
          let manManagementSummary = [
            {
              name: this.$t("Management.Management"),
              id: this.$t("Management.Management"),
              num: res.data.employees,
            },
            {
              name: this.$t("Management.ContactInfo"),
              id: this.$t("Management.ContactInfo"),
              num: res.data.contacts,
            },
            {
              name: this.$t("Management.Countries"),
              id: this.$t("Management.Countries"),
              num: res.data.countries,
            },
          ];
          this.$emit("UpdatamarkTotalList", manManagementSummary);
        } else {
          this.$emit("UpdatamarkTotalList", []);
        }
      });
    },
    getCompanyManagemenList() {
      const id3a = this.$route.query.id3a;
      getCompanyManagement({
        id3a: id3a,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        email: this.SearchEmail,
        positionCode: this.PostionsvValue,
        countryCode: this.value,
      })
        .then((Res) => {
          if (Res.code == 200) {
            this.tableData = Res.data.rows;

            this.page.total = Res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    getManagementFilter() {
      const id3a = this.$route.query.id3a;
      getManagementFilter({
        id3a: id3a,
      }).then((res) => {
        this.tableDataPostion = res.position;
        this.tableDataCountry = res.country;
      });
    },
    selectList(val, title) {
      if (this.powerArr[1]?.hasPrivilege) {
        if (val == "name") {
          this.getPersonDetail(title);
        } else {
          this.detailOrList = val;
          this.title = title;
          this.getPersonRelateCompanyList(title);
        }

        this.detailTitle = title?.name;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    }, // cutSelectPositon
    getPersonRelateCompanyList(value) {
      getPersonRelateCompany({
        id3a: this.$route.query.id3a,
        pid: value.pid,
        page: this.pageTwo.pageNo,
        pageSize: this.pageTwo.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.detailData = res.data.rows;

          this.pageTwo.total = res.data.total;
        } else {
          this.detailData = [];
        }
      });
    },
    getPersonDetail(value) {
      this.Loading = true;
      getPersonProfile({ id3a: this.$route.query.id3a, pid: value.pid }).then(
        (res) => {
          if (res.code == 200) {
            this.Loading = false;
            this.persinDetail = res.data;
          } else {
            this.Loading = false;
            this.persinDetail = {};
          }
        },
      );
    },

    MoreList(val) {
      if (val) {
        if (this.page.total > this.page.pageSize) {
          this.page.pageSize = this.page.pageSize + 10;

          this.getCompanyManagemenList();
        }
      } else {
        if (this.pageTwo.total > this.pageTwo.pageSize) {
          this.pageTwo.pageSize = this.pageTwo.pageSize + 5;

          this.getPersonRelateCompanyList(this.title);
        }
      }
    },
    cutSelectPositontwo() {
      this.getCompanyManagemenList();
      if (this.PostionsvValue == "") {
        this.showSelectP = true;
      }
    },
    cutSelectPositon(value) {
      //
      setTimeout(() => {
        this.showSelectP = !value;
      }, 100);
    },
    cutSelectCountryvisible(value) {
      if (!value) {
        setTimeout(() => {
          this.showSelectC = true;
        }, 100);
      }
    },
    cutSelectCountryvisiblone(value) {
      if (!value) {
        setTimeout(() => {
          this.showSelectP = true;
        }, 100);
      }
    },
    // cutSelectCountry
    cutSelectCountrytwo() {
      this.getCompanyManagemenList();
      if (this.value == "") {
        setTimeout(() => {
          this.showSelectC = true;
        }, 100);
      }
    },
    cutSelectCountry(value) {
      //
      setTimeout(() => {
        this.showSelectC = !value;
      }, 100);
    },
  },
  computed: {},
};
</script>
<style scoped>
.u9oZ7K7 {
  padding-top: 30px;
}

.uDWVvds {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: max-content;
}

.uwADSr7 {
  display: flex;
  align-items: flex-end;
}

.ua9b69 {
  font-family: "Arial Bold";
}

.urIvokP {
  margin-left: 22px;
}

.u74df0 {
  display: flex;
  justify-content: center;
}

.ufa40e {
  height: 64px;
  line-height: 64px;
  color: #1290c9;
}

.u9rstct {
  font-size: 20px;
}

/* .uo4Jucf {
  margin-top: -0.5714285714285714em;
} */

.uvCLCSZ {
}

.usGh36L {
  margin-top: -8px;
}

.uUXjuvB {
  display: flex;
  width: 100%;
  margin-bottom: 30px;
}

.uUXjuvB:last-child {
  margin-bottom: 0;
}

.u19uWWd {
  width: 48%;
  margin-right: 4%;
}

.u8iAMza {
  line-height: 1.5;
  font-size: 20px;
  color: #29445d;
}

.ue7XKb9 {
  font-size: 20px;
  color: #29445d;
}

.u87e66 {
  color: #1290c9;
  text-decoration: underline;
  cursor: pointer;
}

.u57b2e {
  display: flex;
  align-items: start;
}

.srcviewscompanydetailsBackgroundManagementvuecssEnd {
}

.u9f344 .el-table th.el-table__cell:nth-child(2) > .cell,
.u9f344 .el-table th.el-table__cell:nth-child(4) > .cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.u9f344 .el-table td.el-table__cell:nth-child(7) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.u9f344 .center_con {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 49.1.6428571428571428em;
  cursor: pointer;
}

.u9f344 .el-popover__reference-wrapper {
  display: flex;
}

.u9f344 .uUIRzUi {
  padding: 38px 52px 0;
  min-height: calc(100vh - 422px);
  display: flex;
  flex-direction: column;
}

.u9f344 .table_X {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.u9f344 .mgmt_table_body {
  flex: 1;
  min-height: 0;
}

.u9f344 .u74df0 {
  margin-top: auto;
}

.u9f344 .u2bddc {
  display: block;
}

.pb30 {
  padding-bottom: 38px;
}

.u9f344 .el-input .el-input__inner {
  border: 1px solid #8497ab;
}

.u9f344 th {
  height: 64px;
  padding: 3px 0 1px !important;
}

.tbl_search {
  position: relative;
  z-index: 9;
}

.tbl_search2 {
  position: absolute;
}

.tbl_search svg {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  pointer-events: none;
}

.tbl_search /deep/ .el-input__inner {
  padding-right: 44px;
}

.table_box {
  position: relative;
}

.tbl_search /deep/.el-input .el-input__suffix {
  right: 40px;
}

/deep/.el-input__inner,
.el-input__inner:focus {
  font-size: 20px;
  color: #1a2332;
  border: 1px solid #8497ab;
}

.Verificati-img {
  height: 25px;
  width: 32px;
}

.Management-people-box {
}

.Management-people-box-head {
  position: relative;

  width: fit-content;
}

.anagement-people-box-name {
  display: block;
  padding-bottom: 8px;
  border-bottom: 2px solid #1290c9;
  margin-right: 10px;
  font-family: "Arial Bold";
  font-size: 24px;
  line-height: 26px;
  color: #1290c9;
}

.anagement-people-box-name:last-child {
  margin-right: 0px;
}

.anagement-people-box-heng {
  position: absolute;
  top: 30px;
  height: 2px;

  background: #1290c9;
  width: 100%;
}

.anagement-people-box-nametwo {
  border: none;
  color: #1a2332;
}

.Management-people-content {
  font-size: 18px;
  color: #999999;
  margin-right: 11px;
}

.Management-people-content-black {
  font-size: 18px;
  color: #1a2332;
  width: 61%;
  word-break: keep-all;
  text-align: left;
  margin-right: 0px;
}

.right_cont_box {
  padding-top: 0px;
  padding: 0px;
}

.tbl_search-Num {
  font-size: 18px;
  line-height: 24px;
  color: #666666;
  display: flex;
  align-items: end;
  margin-bottom: 10px;
}

.table_add {
  font-family: "Arial Bold";
}

.Back-blue {
  /* padding: 1.42857143rem; */
  color: #ffffff;
  font-size: 18px;
  margin-right: 10px;
  background: #1290c9;
  height: 50px;
  line-height: 50px;
  width: 100px;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 10px;
}

.mgmt_page_root ::v-deep .el-dialog__body .search_rsult_txt {
  left: 5px;
}

.mgmt_page_root ::v-deep .el-dialog__body .pageBox_right {
  margin-right: 5px;
}

.mgmt_page_root_dialog_title{
  margin: 0 5px 20px;
}

@media screen and (max-width: 1920px) {
  .u9oZ7K7 {
    padding-top: 22px;
  }

  .urIvokP {
    margin-left: 16px;
  }

  .ufa40e {
    height: 48px;
    line-height: 48px;
  }

  .u9rstct {
    font-size: 16px;
  }

  .usGh36L {
    margin-top: -6px;
  }

  .uUXjuvB {
    margin-bottom: 22px;
  }

  .u8iAMza {
    font-size: 16px;
  }

  .ue7XKb9 {
    font-size: 16px;
  }

  .u9f344 .uUIRzUi {
    padding: 28px 39px 0;
    min-height: calc(100vh - 430px);
  }

  .pb30 {
    padding-bottom: 28px;
  }

  .u9f344 th {
    height: 48px;
  }

  .tbl_search svg {
    right: 9px;
    width: 18px;
    height: 18px;
  }

  .Verificati-img {
    height: 18px;
    width: 24px;
  }

  .anagement-people-box-name {
    padding-bottom: 6px;
    margin-right: 7px;
    font-size: 18px;
    line-height: 20px;
  }

  .anagement-people-box-heng {
    top: 22px;
  }

  .Management-people-content {
    font-size: 16px;
    margin-right: 8px;
  }

  .Management-people-content-black {
    font-size: 16px;
  }

  .tbl_search-Num {
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 0;
  }

  .Back-blue {
    font-size: 16px;
    margin-right: 7px;
    height: 38px;
    line-height: 38px;
    width: 75px;
    border-radius: 7px;
    margin-bottom: 7px;
  }

  .table_add {
    font-size: 16px;
  }

  .mgmt_page_root_dialog_title{
    margin: 0 5px 15px;
  }

  .Management-people-content{
    min-width: 130px;
  }

  .people_detail{
    height: 32px;
  }
}

@media screen and (max-width: 1439px) {
  .u9oZ7K7 {
    padding-top: 20px;
  }

  .urIvokP {
    margin-left: 14px;
  }

  .ufa40e {
    height: 42px;
    line-height: 42px;
  }

  .u9rstct {
    font-size: 14px;
  }

  .usGh36L {
    margin-top: -5px;
  }

  .uUXjuvB {
    margin-bottom: 20px;
  }

  .u8iAMza {
    font-size: 14px;
  }

  .ue7XKb9 {
    font-size: 14px;
  }

  .u9f344 .uUIRzUi {
    padding: 25px 34px 0;
    min-height: calc(100vh - 415px);
  }

  .pb30 {
    padding-bottom: 28px;
  }

  .u9f344 th {
    height: 42px;
  }

  .tbl_search svg {
    right: 8px;
    width: 16px;
    height: 16px;
  }

  .Verificati-img {
    height: 16px;
    width: 22px;
  }

  .anagement-people-box-name {
    padding-bottom: 5px;
    margin-right: 6px;
    font-size: 16px;
    line-height: 18px;
  }

  .anagement-people-box-heng {
    top: 20px;
  }

  .Management-people-content {
    font-size: 14px;
    margin-right: 7px;
  }

  .Management-people-content-black {
    font-size: 14px;
  }

  .tbl_search-Num {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 6px;
  }

  .Back-blue {
    font-size: 14px;
    margin-right: 6px;
    height: 32px;
    line-height: 32px;
    width: 68px;
    border-radius: 6px;
    margin-bottom: 6px;
  }
  
  .table_add {
    font-size: 14px;
  }

  .people_detail{
    height: 28px;
  }

  .Management-people-content{
    min-width: 110px;
  }
}
</style>

<style>
.mgmt_page_root .uae104 {
  margin-bottom: 20px;
}

.mgmt_table {
  border: none;
  border-collapse: collapse;
}

.mgmt_alert_table .el-table__body-wrapper{
  height: 500px !important;
  overflow-x: hidden;
  overflow-y: auto;
}


.mgmt_table thead,
.mgmt_table .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.mgmt_table td,
.mgmt_table td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.mgmt_main_table .el-table__body-wrapper .el-table__row td:last-child,
.mgmt_main_table .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.mgmt_main_table::after {
  display: none !important;
}

.mgmt_main_table.el-table {
  overflow: hidden;
}

.mgmt_table .el-table__cell > .cell {
  font-size: 18px;
  line-height: 24px;
}

.mgmt_main_table .el-table__cell:first-child > .cell {
  padding-left: 20px !important;
}

.mgmt_main_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
  padding-right: 10px !important;
}

.mgmt_main_table
  .el-table__header-wrapper
  th.el-table__cell:nth-last-child(2)
  > .cell {
  padding-right: 10px !important;
}

.mgmt_alert_table .el-table__body-wrapper .el-table__row td:last-child,
.managemeukIKpazntTable .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.mgmt_alert_table::after {
  display: none !important;
}

.mgmt_alert_table.el-table {
  overflow: hidden;
}

.mgmt_alert_table .el-table__cell:first-child > .cell {
  padding-left: 30px !important;
}

.mgmt_alert_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
  padding-right: 40px !important;
}

.mgmt_alert_table
  .el-table__header-wrapper
  th.el-table__cell:nth-last-child(2)
  > .cell {
  padding-right: 40px !important;
}

.mgmt_alert_table
  .el-table__header-wrapper
  th.el-table__cell:first-child
  > .cell
  > span {
  display: flex;
  align-items: center;
}

.mgmt_page_root .mgmt_input .el-input .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  font-size: 16px;
}

.el-select-dropdown__item {
  font-size: 16px !important;
}

.back_div {
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.back_div_icon {
  width: 26px;
  height: 24px;
}

.mgmt_right_title {
  font-size: 20px;
  line-height: 30px;
}

.main_icon_search {
  width: 28px;
  height: 28px;
}

.mgmt_alert_context_icon_search {
  width: 24px;
  height: 24px;
}

.mgmt_input_alert_name .el-input__inner,
.mgmt_input_alert_website .el-input__inner {
  font-size: 16px !important;
}

.mgmt_input_alert_name {
  width: 300px;
  margin-top: 3px;
}

.mgmt_input_alert_website {
  width: 400px;
}

.Management-people.el-popover {
  width: 480px;
  background: #f8fbff;
  box-shadow: 0px 2px 6px 0px rgba(71, 109, 127, 0.2);
  border-radius: 14px;
  padding: 30px !important;
}

.dialog_normalmengent .el-dialog__body {
  padding: 20px !important;
}

@media screen and (max-width: 1920px) {
  .mgmt_page_root .uae104 {
    margin-bottom: 25px;
    line-height: 40px;
  }
  
  .mgmt_alert_table .el-table__body-wrapper{
    height: 500px !important;
  }

  .mgmt_table thead,
  .mgmt_table .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .mgmt_table td,
  .mgmt_table td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .mgmt_table .el-table__cell > .cell {
    font-size: 16px;
    line-height: 24px;
  }

  .mgmt_main_table .el-table__cell:first-child > .cell {
    padding-left: 15px !important;
  }

  .mgmt_main_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 7px !important;
  }

  .mgmt_main_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 7px !important;
  }

  .mgmt_alert_table .el-table__cell:first-child > .cell {
    padding-left: 22px !important;
  }

  .mgmt_alert_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 30px !important;
  }

  .mgmt_alert_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 30px !important;
  }

  .mgmt_page_root .mgmt_input .el-input .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    font-size: 14px;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
  }

  .back_div {
    margin-right: 22px;
  }

  .back_div_icon {
    width: 20px;
    height: 18px;
  }

  .mgmt_right_title {
    font-size: 16px;
    line-height: 22px;
  }

  .main_icon_search {
    width: 22px;
    height: 22px;
  }

  .mgmt_alert_context_icon_search {
    width: 18px;
    height: 18px;
  }

  .mgmt_input_alert_name .el-input__inner,
  .mgmt_input_alert_website .el-input__inner {
    font-size: 14px !important;
  }

  .mgmt_input_alert_name {
    width: 220px;
    margin-top: 3px;
  }

  .mgmt_input_alert_website {
    width: 300px;
  }

  .Management-people.el-popover {
    width: 400px;
    border-radius: 10px;
    padding: 22px !important;
  }

  .dialog_normalmengent .el-dialog__body {
    padding: 20px !important;
  }
}

@media screen and (max-width: 1439px) {
  .mgmt_page_root .uae104 {
    margin-bottom: 12px;
  }

  .mgmt_alert_table .el-table__body-wrapper{
    height: 450px !important;
  }

  .mgmt_table thead,
  .mgmt_table .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .mgmt_table td,
  .mgmt_table td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .mgmt_table .el-table__cell > .cell {
    font-size: 14px;
    line-height: 20px;
  }

  .mgmt_main_table .el-table__cell:first-child > .cell {
    padding-left: 12px !important;
  }

  .mgmt_main_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 6px !important;
  }

  .mgmt_main_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 6px !important;
  }

  .mgmt_alert_table .el-table__cell:first-child > .cell {
    padding-left: 20px !important;
  }

  .mgmt_alert_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 26px !important;
  }

  .mgmt_alert_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 26px !important;
  }

  .mgmt_page_root .mgmt_input .el-input .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 14px;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
  }

  .back_div {
    margin-right: 20px;
  }

  .back_div_icon {
    width: 18px;
    height: 16px;
  }

  .mgmt_right_title {
    font-size: 14px;
    line-height: 20px;
  }

  .main_icon_search {
    width: 20px;
    height: 20px;
  }

  .mgmt_alert_context_icon_search {
    width: 16px;
    height: 16px;
  }

  .mgmt_input_alert_name .el-input__inner,
  .mgmt_input_alert_website .el-input__inner {
    font-size: 14px !important;
  }

  .mgmt_input_alert_name {
    width: 200px;
    margin-top: 0;
  }

  .mgmt_input_alert_website {
    width: 260px;
  }

  .Management-people.el-popover {
    width: 350px;
    border-radius: 10px;
    padding: 20px !important;
  }

  .dialog_normalmengent .el-dialog__body {
    padding: 15px !important;
  }
}
</style>
